import { render, staticRenderFns } from "./Level4CategoryMenu.vue?vue&type=template&id=3a273a0a&scoped=true&"
import script from "./Level4CategoryMenu.vue?vue&type=script&lang=js&"
export * from "./Level4CategoryMenu.vue?vue&type=script&lang=js&"
import style0 from "./Level4CategoryMenu.vue?vue&type=style&index=0&id=3a273a0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a273a0a",
  null
  
)

export default component.exports